import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { actionCreators as homeActions } from '~screens/Dashboard/screens/Home/redux/actions';
import { addProductToShoppingCart } from '~models/shoppingCart';
import { useLoyalty } from '~hooks/useLoyalty';

import { getFreeProduct } from './utils';

export const useFreeProduct = () => {
  const dispatch = useDispatch();

  const { shoppingCart, shoppingCartLoading, flattenedMenu } = useSelector(state => state.home);
  const { level } = useLoyalty();

  const product = getFreeProduct(level?.loyaltyBenefits);

  const productToBeAdded = useMemo(
    () => Object.values(flattenedMenu || []).find(item => item.menuableId === product?.id),
    [product?.id]
  );

  const isAvailable = useMemo(
    () =>
      Object.values(flattenedMenu || []).some(
        ({ menuableId }) => menuableId === productToBeAdded?.menuableId
      ),
    [productToBeAdded]
  );

  const productHasBeenAdded = shoppingCart.items.some(
    item => item?.menuableId === product?.id && item?.price === item?.discount
  );

  const amountRequired = Math.max(0, product?.minAmount - shoppingCart?.subtotal);

  const addProduct = () =>
    productToBeAdded &&
    dispatch(
      homeActions.getCartPrices(
        addProductToShoppingCart(shoppingCart?.items, {
          menuableId: productToBeAdded?.menuableId,
          menuableType: productToBeAdded?.menuableType,
          quantity: 1
        })
      )
    );

  return {
    product,
    amountRequired,
    canBeAdded: !amountRequired,
    addProduct,
    loading: shoppingCartLoading,
    renderComponent: [product, isAvailable, !productHasBeenAdded].every(Boolean)
  };
};
